import { BillingFrequency } from '../domain'

const FREQUENCY_MULTIPLIERS: Record<BillingFrequency, number | null> = {
  MONTHLY: 1,
  QUARTERLY: 3,
  HALF_YEARLY: 6,
  YEARLY: 12,
  ONE_TIME: null,
  ON_DEMAND: null,
  PER_EVENT: null
}

export const getBillingFrequencyMultiplier = (params: {
  fromFrequency: BillingFrequency
  toFrequency: BillingFrequency
}) => {
  const fromMultiplier = FREQUENCY_MULTIPLIERS[params.fromFrequency]
  const toMultiplier = FREQUENCY_MULTIPLIERS[params.toFrequency]

  /**
   * When a multiplier is not valid, then we will return 1 (i.e. no change to be applied).
   */
  if (!fromMultiplier || !toMultiplier) {
    return 1
  }

  return toMultiplier / fromMultiplier
}
